// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LightbulbOutlinedSvg from "@fishx/icons-svg/es/asn/LightbulbOutlined";
import FishxIcon from '../components/FishxIcon';

var LightbulbOutlined = function LightbulbOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LightbulbOutlinedSvg
  }));
};

LightbulbOutlined.displayName = 'LightbulbOutlined';
export default React.forwardRef(LightbulbOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LightbulbOutlined.js
// module id = 3038
// module chunks = 0